import React, { useState,useEffect } from 'react';
import axios from 'axios';
import './App.css';


const LoanData = () => {
  const [BankList, setBankList] = useState([]);
  const [formData, setFormData] = useState({
    loanName: '',
    bannerHeading: '',
    bannerSubHeading: '',
    contentHeading: '',
    contentSubHeading: '',
    tableHeading: '',
    tableData: BankList
  });

  const [tableData, setTableData] = useState({
    bankName: "",
    bankImage: '',
    interestRate: "",
    processingFee: "",
    loanAmount: "",
    tenure: "",
    eligibility: "",
    documents: "",
    emiDueDate: "",
    preclosureCharges: "",
    partPaymentCharges: "",
    cibilScore: "",
    age: "",
    topUpLoan: "",
    minimumSalary: "",
    balanceTransferToOtherBank: "",
    balanceTransferToSameBank: ""
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
     if (name in tableData) {
      setTableData({
        ...tableData,
        [name]: value
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.keys(formData).forEach(key => {
      if (key === "tableData") {
        formData.tableData.forEach((bank, index) => {
          Object.keys(bank).forEach(bankKey => {
  
              data.append(`tableData[${index}][${bankKey}]`, bank[bankKey]);
            
          });
        });
      } else {
        data.append(key, formData[key]);
      }
    });

    try {
      const response = await axios.post('https://api.dremerz.net/api/bankshoppyloan', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      console.log('Response:', response.data);
      alert('Data submitted successfully!');
    } catch (error) {
      console.error('Error submitting data:', error);
      alert('Error submitting data. Please try again.');
    }
  };

  const handleAddBank = (e) => {
    e.preventDefault();
    setBankList([...BankList, tableData]);
    setFormData({
      ...formData,
      tableData: [...BankList, tableData]
    });
    setTableData({
      bankName: "",
      bankImage: null,
      interestRate: "",
      processingFee: "",
      loanAmount: "",
      tenure: "",
      eligibility: "",
      documents: "",
      emiDueDate: "",
      preclosureCharges: "",
      partPaymentCharges: "",
      cibilScore: "",
      age: "",
      topUpLoan: "",
      minimumSalary: "",
      balanceTransferToOtherBank: "",
      balanceTransferToSameBank: ""
    });
    alert('Bank details added successfully!');
  };


  const [listdata,setListData]=useState([])
  
  useEffect(()=>{
    axios.get ('https://api.dremerz.net/api/bankshoppyloan')
    .then((res)=>{
      console.log(res.data)
      setListData(res.data)
    })
    .catch((err)=>{
      console.log(err)
    })
  },[])
  return (
    <>

<br /> <br /> <br />
      <div className="form-container">
        <h2>Loan Data Form</h2>
        <form>
          <div className="form-group">
            <label>Loan Name:</label>
            <input
              type="text"
              name="loanName"
              value={formData.loanName}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Banner Heading:</label>
            <input
              type="text"
              name="bannerHeading"
              value={formData.bannerHeading}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Banner SubHeading:</label>
            <input
              type="text"
              name="bannerSubHeading"
              value={formData.bannerSubHeading}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Content Heading:</label>
            <input
              type="text"
              name="contentHeading"
              value={formData.contentHeading}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Content SubHeading:</label>
            <input
              type="text"
              name="contentSubHeading"
              value={formData.contentSubHeading}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Table Heading:</label>
            <input type="text" name="tableHeading" value={formData.tableHeading} onChange={handleChange} />
          </div>
        </form>
      </div>

      <div className="form-container">
        <h2>Add Bank Details</h2>
        <form onSubmit={handleAddBank}>
          <div className="form-group">
            <label>Bank Name:</label>
            <input type="text" name="bankName" value={tableData.bankName} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Bank Image:</label>
            <input type="text" name="bankImage" onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Interest Rate:</label>
            <input type="text" name="interestRate" value={tableData.interestRate} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Processing Fee:</label>
            <input type="text" name="processingFee" value={tableData.processingFee} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Loan Amount:</label>
            <input type="text" name="loanAmount" value={tableData.loanAmount} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Tenure:</label>
            <input type="text" name="tenure" value={tableData.tenure} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Eligibility:</label>
            <input type="text" name="eligibility" value={tableData.eligibility} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Documents:</label>
            <input type="text" name="documents" value={tableData.documents} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>EMI Due Date:</label>
            <input type="text" name="emiDueDate" value={tableData.emiDueDate} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Preclosure Charges:</label>
            <input type="text" name="preclosureCharges" value={tableData.preclosureCharges} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Part Payment Charges:</label>
            <input type="text" name="partPaymentCharges" value={tableData.partPaymentCharges} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>CIBIL Score:</label>
            <input type="text" name="cibilScore" value={tableData.cibilScore} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Age:</label>
            <input type="text" name="age" value={tableData.age} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Top Up Loan:</label>
            <input type="text" name="topUpLoan" value={tableData.topUpLoan} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Minimum Salary:</label>
            <input type="text" name="minimumSalary" value={tableData.minimumSalary} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Balance Transfer to Other Bank:</label>
            <input type="text" name="balanceTransferToOtherBank" value={tableData.balanceTransferToOtherBank} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Balance Transfer to Same Bank:</label>
            <input type="text" name="balanceTransferToSameBank" value={tableData.balanceTransferToSameBank} onChange={handleChange} />
          </div>
          <button type="submit" className="submit-button">Add Bank</button>
        </form>
      </div>

      <div className="table-container">
        <h2>Bank Details</h2>
        <table>
          <thead>
            <tr>
              <th>Bank Name</th>
              <th>Bank Image</th>
              <th>Interest Rate</th>
              <th>Processing Fee</th>
              <th>Loan Amount</th>
              <th>Tenure</th>
              <th>Eligibility</th>
              <th>Documents</th>
              <th>EMI Due Date</th>
              <th>Preclosure Charges</th>
              <th>Part Payment Charges</th>
              <th>CIBIL Score</th>
              <th>Age</th>
              <th>Top Up Loan</th>
              <th>Minimum Salary</th>
              <th>Balance Transfer to Other Bank</th>
              <th>Balance Transfer to Same Bank</th>
            </tr>
          </thead>
          <tbody>
            {BankList.map((bank, index) => (
              <tr key={index}>
                <td>{bank.bankName}</td>
                <td>{bank.bankImage && <img src={bank.bankImage} alt="Bank Logo" />}</td>
                <td>{bank.interestRate}</td>
                <td>{bank.processingFee}</td>
                <td>{bank.loanAmount}</td>
                <td>{bank.tenure}</td>
                <td>{bank.eligibility}</td>
                <td>{bank.documents}</td>
                <td>{bank.emiDueDate}</td>
                <td>{bank.preclosureCharges}</td>
                <td>{bank.partPaymentCharges}</td>
                <td>{bank.cibilScore}</td>
                <td>{bank.age}</td>
                <td>{bank.topUpLoan}</td>
                <td>{bank.minimumSalary}</td>
                <td>{bank.balanceTransferToOtherBank}</td>
                <td>{bank.balanceTransferToSameBank}</td>
              </tr>
            ))}
          </tbody>
        </table>
       
      </div>

      <div style={{display:"flex",justifyContent:"center"}}>
      <button
          type="submit"
          style={{
            width: "300px",
          }}
          className="submit-button"
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>

      <br></br>
      <br></br>
      <table>
          <thead>
            <tr>
              <th>Investment Name</th>
              <th>Actions</th>
              </tr>
              </thead>
              <tbody>
              {listdata.map((item, index) => (
              <tr key={index}>
                <td>{item.loanName}</td>
                <td>
                  <button onClick={() => {
                    axios.delete(`https://api.dremerz.net/api/bankshoppyloan/${item.id}`)
                    .then((res) => {
                      console.log(res);
                      alert('Data deleted successfully!');
                    })
                    .catch((err) => {
                      console.error('Error deleting data:', err);
                      alert('Error deleting data. Please try again.');
                    });
                  }}>Delete</button>
                </td>
              </tr>
            ))}
            </tbody>
            </table>
      <br></br>
      <br></br>

      <style
  dangerouslySetInnerHTML={{
    __html:
      '\n\n\n\nbody {\n  font-family: Arial, sans-serif;\n  background-color: #f4f4f4;\n  margin: 0;\n  padding: 0;\n}\n\n.form-container {\n  max-width: 600px;\n  margin: 20px auto;\n  padding: 20px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\nh2 {\n  text-align: center;\n  color: #333;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\ninput[type="text"],\ninput[type="file"] {\n  width: 100%;\n  padding: 8px;\n  margin: 5px 0 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.submit-button {\n  display: inline-block;\n  width: 100%;\n  padding: 10px;\n  background-color: #007bff;\n  border: none;\n  border-radius: 4px;\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n  text-align: center;\n  transition: background-color 0.3s ease;\n}\n\n.submit-button:hover {\n  background-color: #0056b3;\n}\n\n.table-container {\n  max-width: 1000px;\n  margin: 20px auto;\n  padding: 20px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: scroll;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\nth, td {\n  padding: 10px;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\nth {\n  background-color: #007bff;\n  color: white;\n}\n\nimg {\n  max-width: 100px;\n  height: auto;\n  display: block;\n}\n\n      '
  }}
/>

    </>
  );
};

export default LoanData;
